import apiSlice from './ApiSlice';

export const campaignApi = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        // GET ALL
        getAllCampaign: builder.query({
            providesTags: ["campaign"],
            query: () => {
                return {
                    url: '/campaign',
                    method: 'GET',
                };
            },
        }),

          // GET ALL WITH PAGINATION
          getAllCampaignWithPagination: builder.query({
            providesTags: ["campaign"],
            query: () => {
                return {
                    url: '/campaign',
                    method: 'POST',
                };
            },
        }),
        // Add 
        addCampaign: builder.mutation({
            invalidatesTags: ["campaign"],
            query: (body) => {
                return {
                    url: '/campaign/add',
                    method: 'POST',
                    body
                };
            },
        }),

        // EDIT
        editCampaign: builder.mutation({
            invalidatesTags: ["campaign"],
            query: ({ body, id }: any) => {
                return {
                    url: `/campaign/${id}`,
                    method: 'PUT',
                    body
                };
            },
        }),

        //Single View
        viewCampaignById: builder.query({
            providesTags: ["campaign"],
            query: (id: any) => {
                return {
                    url: `/campaign/${id}`,
                    method: "GET",
                };
            },
        }),

        // Delete
        deleteCampaign: builder.mutation({
            invalidatesTags: ["campaign"],
            query: (id: string) => {
                return {
                    url: `/campaign/${id}`,
                    method: 'DELETE',
                };
            },
        }),
    }),
});

export const { useGetAllCampaignQuery, useDeleteCampaignMutation , useAddCampaignMutation , useEditCampaignMutation , useViewCampaignByIdQuery , useGetAllCampaignWithPaginationQuery} = campaignApi;